const moreBookingsCarousel = require('../components/moreBookingsCarousel').moreBookingsCarousel;

new moreBookingsCarousel();

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Enables Slick only below 700px and destroys it above.
	 * This allows you to keep your "custom layout" on desktop/tablet,
	 * and use a slider only on small screens.
	 */
	function classesLandingPageCarouselInit() {
		// If you have multiple sections, handle each independently
		const carousels = document.querySelectorAll(
			'.content-section--any-classes .key-benefits__row'
		);

		if (!carousels.length) return;

		const btnBar = document.querySelector('.content-section--any-classes .key-benefits__col-toggler');
		const BREAKPOINT = 700;
		const sliderArrowPrev = `<button class="slider-nav-btn slider-nav-btn--prev" aria-label="Previous">
											<svg aria-hidden="true" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
											  <path d="M10.1577 16.5957C10.0405 16.7422 9.80615 16.7422 9.65967 16.5957L3.53662 10.4727C3.39014 10.3262 3.39014 10.1211 3.53662 9.97461L9.65967 3.85156C9.80615 3.70508 10.0405 3.70508 10.1577 3.85156L10.7437 4.4082C10.8901 4.55469 10.8901 4.78906 10.7437 4.90625L6.20264 9.44727L16.2222 9.44727C16.3979 9.44727 16.5737 9.62305 16.5737 9.79883V10.6191C16.5737 10.8242 16.3979 10.9707 16.2222 10.9707L6.20264 10.9707L10.7437 15.541C10.8901 15.6582 10.8901 15.8926 10.7437 16.0391L10.1577 16.5957Z" fill="#0B3052"/>
											</svg>
										  </button>`;

		const sliderArrowNext = `<button class="slider-nav-btn slider-nav-btn--next" aria-label="Next">
										<svg aria-hidden="true" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
										  <path d="M9.82812 3.85156C9.94531 3.70508 10.1797 3.70508 10.3262 3.85156L16.4492 9.97461C16.5957 10.1211 16.5957 10.3262 16.4492 10.4727L10.3262 16.5957C10.1797 16.7422 9.94531 16.7422 9.82812 16.5957L9.24219 16.0391C9.0957 15.8926 9.0957 15.6582 9.24219 15.541L13.7832 10.9707H3.79297C3.58789 10.9707 3.44141 10.8242 3.44141 10.6191V9.79883C3.44141 9.62305 3.58789 9.44727 3.79297 9.44727H13.7832L9.24219 4.90625C9.0957 4.78906 9.0957 4.55469 9.24219 4.4082L9.82812 3.85156Z" fill="#0B3052"/>
										</svg>
									  </button>`;

		/**
		 * Initialize Slick for a single carousel element (if not initialized).
		 */
		function initCarousel(carouselEl) {
			const $carousel = window.jQuery ? window.jQuery(carouselEl) : null;
			if (!$carousel || !$carousel.length) return;

			btnBar?.remove();

			// Prevent double init
			if ($carousel.hasClass('slick-initialized')) return;

			$carousel.slick({
				autoplay: true,
				autoplaySpeed: 3000,
				pauseOnFocus: true,
				pauseOnHover: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: sliderArrowPrev,
				nextArrow: sliderArrowNext,
				dots: false,
				accessibility: true,
				adaptiveHeight: true,
			});
		}

		/**
		 * Destroy Slick for a single carousel element (if initialized).
		 */
		function destroyCarousel(carouselEl) {
			btnBar?.remove();

			const $carousel = window.jQuery ? window.jQuery(carouselEl) : null;
			if (!$carousel || !$carousel.length) return;

			if (!$carousel.hasClass('slick-initialized')) return;

			$carousel.slick('unslick');
		}

		/**
		 * Apply correct mode based on current viewport width.
		 */
		function update() {
			const isMobile = window.innerWidth < BREAKPOINT;

			carousels.forEach((carouselEl) => {
				if (isMobile) {
					initCarousel(carouselEl);
				} else {
					destroyCarousel(carouselEl);
				}
			});
		}

		// Run once on load
		update();

		// Re-check on resize (throttled to avoid too many calls)
		let resizeTimer = null;
		window.addEventListener('resize', () => {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(update, 150);
		});
	}

	classesLandingPageCarouselInit();
});
